import endpoints from './api-endpoint-definition.json';
import { LabelValue } from '../../_models/label-value';
import { ApiCall } from '@lcms/api-definition';

export type  ResourceTypesResponse = LabelValue[]

const definition = new ApiCall<ResourceTypesResponse>().get('resourceTypes', { route: endpoints.resourceTypes })
export default definition;